import { RootState } from '@algoan/dashboard/store/store';
import { Organization } from '@algoan/dashboard/model';

export const organizationSelector = (state: RootState): Organization | undefined => state.organization.organization;
